import { PicklistSummary } from './PicklistSummary';

export default PicklistSummary;
